class TokenService {
  getLocalRefreshToken () {
    const login = JSON.parse(localStorage.getItem('login'))

    if (!login) {
      return null
    }

    return login.refreshToken
  }

  getLocalAccessToken () {
    const login = JSON.parse(localStorage.getItem('login'))

    if (!login) {
      return null
    }

    return login.accessToken
  }

  getLoginId () {
    const login = JSON.parse(localStorage.getItem('login'))

    if (!login) {
      return 0
    }

    return login.loginId
  }

  updateLocalAccessData (accessData) {
    let login = JSON.parse(localStorage.getItem('login'))
    login.accessToken = accessData.accessToken
    login.refreshToken = accessData.refreshToken
    localStorage.setItem('login', JSON.stringify(login))
  }

  getLogin () {
    return JSON.parse(localStorage.getItem('login'))
  }

  setLogin (login) {
    localStorage.setItem('login', JSON.stringify(login))
  }

  removeLogin () {
    localStorage.removeItem('login')
  }
}

export default new TokenService()



// WEBPACK FOOTER //
// ./src/services/auth/TokenService.js